import { AirDateInfoSkeleton } from './air-date-info'
import { CampaignActionsSkeleton } from './campaign-actions'
import { DealInfoSkeleton } from './deal-info'
import { UnallocatedInfoSkeleton } from './unallocated-info'

export const OrderItemGridCardSkeleton = () => {
  return (
    <div className="space-y-1 w-[388px]">
      <div className="bg-surface-bg-inverse shadow-md p-4 h-auto border-2 border-border mx-auto">
        <DealInfoSkeleton layout="grid" />
        <AirDateInfoSkeleton layout="grid" />
        <UnallocatedInfoSkeleton layout="grid" />
        <CampaignActionsSkeleton layout="grid" />
      </div>
    </div>
  )
}
